
stickyHeaderDirective = (Page) ->
    'ngInject'

    restrict: 'C'
    link: (scope, element, attrs) ->

        scrollContainer = Page.element()

        refresh = ->
            element.removeClass('sticky')
            rect = element[0].getBoundingClientRect()
            element.toggleClass('sticky', rect.top <= 0)
            return

        scrollContainer.on('scroll', refresh)
        scope.$on('resize', refresh)
        scope.$on('$destroy', -> scrollContainer.off('scroll', refresh))

        refresh()

module.directive 'stickyHeader', stickyHeaderDirective
